import { isEmail } from 'validator';

import {
  addressProperties,
  addressRequired,
  customValidate
} from 'common/components/address/validators';
import { validateForUI } from 'common/helpers/jsonValidator';

const loggedInCustomer = () => {
  const schema = {
    type: 'object',
    properties: addressProperties,
    required: addressRequired,
    additionalProperties: false
  };
  schema.properties.customerAddressId = { type: 'string' };
  schema.properties.giftMessage = { type: 'string' };
  schema.properties.shippingInstructions = { type: 'string' };
  return schema;
};

const notLoggedInCustomerShip = () => {
  const schema = {
    type: 'object',
    properties: addressProperties,
    required: [...addressRequired, 'email'],
    additionalProperties: false
  };
  schema.properties.email = { type: 'string' };
  schema.properties.isSubscribe = { type: 'boolean' };
  schema.properties.giftMessage = { type: 'string' };
  schema.properties.shippingInstructions = { type: 'string' };
  return schema;
};

const notLoggedInCustomerPickup = {
  type: 'object',
  properties: {
    email: { type: 'string' },
    isSubscribe: { type: 'boolean' },
    inventoryLocationId: { type: 'string', format: 'uuid' }
  },
  required: ['email'],
  additionalProperties: false
};

const loggedInCustomerPickup = {
  type: 'object',
  properties: {
    inventoryLocationId: { type: 'string', format: 'uuid' }
  },
  required: ['email'],
  additionalProperties: false
};

export const validateForLoggedInCustomerShip = (address, settings) => {
  const errors = validateForUI(
    loggedInCustomer(),
    address,
    customValidate(address, 'shipping', settings)
  );
  return errors;
};

export const validateForNotLoggedInCustomerShip = (address, settings) => {
  const errors = validateForUI(
    notLoggedInCustomerShip(),
    address,
    customValidateNotLoggedInShip(address, settings)
  );
  return errors;
};

export const validateForNotLoggedInCustomerPickup = (address) => {
  const errors = validateForUI(
    notLoggedInCustomerPickup,
    address,
    customValidateNotLoggedInPickup(address)
  );
  return errors;
};

export const validateForLoggedInCustomerPickup = (address) => {
  const errors = validateForUI(loggedInCustomerPickup, address);
  return errors;
};

const customValidateNotLoggedInShip = (address, settings) => {
  const errorArray = customValidate(address, 'shipping', settings);
  if (address.email && !isEmail(address.email)) {
    const error = { field: `email`, message: 'Invalid Email' };
    errorArray.push(error);
  }
  return errorArray;
};

const customValidateNotLoggedInPickup = (address) => {
  const errorArray = [];
  if (address.email && !isEmail(address.email)) {
    const error = { field: `email`, message: 'Invalid Email' };
    errorArray.push(error);
  }
  return errorArray;
};
